import { UserSettings } from "@/config";
import { NicknameRegex } from "@/services/validators";
import { z } from "zod";
import { UserId_Schema } from "@/services/user/userIdSchema";
import { CategoryId_Schema } from "@/services/collection/categories/categoriesSchema";
import { DateTimeIso8601Local_Schema, WholeNumber_Schema } from "@/utilities/schema";

export const Nickname_Schema = z.string().min(UserSettings.nicknameMinLength).max(UserSettings.nicknameMaxLength).regex(NicknameRegex);

export const UserProfile_Schema = z
  .object({
    id: UserId_Schema,
    filterCategories: z
      .object({
        id: CategoryId_Schema,
        name: z.string(),
        count: WholeNumber_Schema,
      })
      .array(),
    publicProfilePhotoUrl: z.string().nullable(),
    nickname: Nickname_Schema,
    publicFullName: z.string(),
    publicEmail: z.string(),
    publicPhone: z.string(),
    publicUrlFacebook: z.string(),
    publicUrlInstagram: z.string(),
    publicUrlTikTok: z.string(),
    publicUrlPinterest: z.string(),
    publicUrlWeb: z.string(),
    publicBioDescription: z.string(),
    isChatEmailNotificationEnabled: z.boolean().optional(),
    holidayUntil: DateTimeIso8601Local_Schema.nullable(),
    // Whether the current user follows this collector; null for anonymous viewers and one's own profile.
    following: z.boolean().nullish(),
    followersCount: WholeNumber_Schema.catch(0),
    // Categories the collector has the most published items in, most first.
    topCategories: z
      .object({
        name: z.string(),
        count: WholeNumber_Schema,
      })
      .array()
      .catch([]),
    // Leaderboard position; null when the collector has not scored yet.
    // Same shape as userSchema's UserStanding_Schema — declared inline because userSchema imports this file.
    standing: z
      .object({
        score: WholeNumber_Schema,
        rank: WholeNumber_Schema,
      })
      .nullish(),

    // There is more, we do not use it, feel free to add it.
  })
  .meta({
    openapi: "PublicCollectorResponse",
  })
  .transform(({ holidayUntil, isChatEmailNotificationEnabled, following, standing, ...rest }) => ({
    ...rest,
    standing: standing ?? null,
    absenceUntil: holidayUntil ?? null,
    isChatEmailNotificationEnabled: isChatEmailNotificationEnabled ?? false, // we want boolean
    following: following ?? null,
  }));
